import { createRouter, createWebHistory } from "vue-router";

import Login from 'views/Login'
import Login_ from 'views/Login-'

import Index from 'views/Index'

import MyOrder from 'views/MyOrder'


// 我
import Me from 'views/me/Index'
// 个人信息
import MyInfo from 'views/me/MyInfo'
// 我的优惠券
import Coupon from 'views/me/Coupon'
// 修改密码
import EditPasswd from 'views/me/EditPasswd'
// 我的推广链接
import MyLink from "../views/me/MyLink";

import ProductList from "../views/ProductList";

import OrderList from "views/OrderList.vue";





const routes = [
    {
        path: '/',
        component: Index
    },
    {
        path: '/login',
        component: Login
    },


    {
        path: '/myorder',
        component: MyOrder
    },
    {
        path: '/order-list/:customer',
        name: 'Login_',
        component: Login_
    },
    {
        path: '/order-list/',
        name: 'OrderList',
        component: OrderList
    },
    {
        path: '/product-list',
        component: ProductList
    },



    {
        path: '/me',
        component: Me
    },
    {
        path: '/myinfo',
        component: MyInfo
    },
    {
        path: '/mylink',
        component: MyLink
    },
    {
        path: '/coupon',
        component: Coupon
    },
    {
        path: '/editPasswd',
        component: EditPasswd

    },
    {
        path: '/:customer',
        component: Login_

    }

];

const router = createRouter({
    history: createWebHistory('/'),
    routes
});

export default router;


